import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import {
    exterirorColorCode,
    fetchTrimData,
    getExteriorColorCode,
    getFeatuerSearch,
    getPrimaryandSecondaryVehicles,
    isExpandedArr,
    PostcompareData,
    postCompareImages,
    searchMake,
    secondarySearch,
    setAdvantagesCheck,
    setCheckedFeature,
    setColorIcon,
    setCompareDataGroupInfo,
    setCompareImages,
    setCategories,
    setRemovedVehicle,
    getSortedCompareTrims,
    secondaryVehiclesTrims,
    storeLockedCompetitors,
    vehicleHasSwapped,
    setTrimVehiclesData,
    setCompareGroupData, setHeaderLoadType,
} from "../../slices/vehicleSlice";
import {useDispatch, useSelector} from "react-redux";
import {Modal, ThemeProvider} from "@mui/material";
import {modalTheme} from "../theme/theme";
import {useTranslation} from "react-i18next";
import {getKeyByValue, getSelectedModel} from "./change.method";
import {trackChangeUpdateVehicle, trackChangeVehicleCancel, trackCompareCompetitors, trackCompareTrims} from "../GoogleTagManager.utils";
import CompareButton from "../modal_selector/trimModal/CompareButton";
import {getCompareGroupData} from "./compare.method";

export const Change = ({
                           setVehicleMake,
                           vehicleMake,
                           years,
                           vehicleData,
                           setVehicleData,
                           setOpenModal,
                           openModal,
                           vehicleModels,
                           vehiclesTrim,
                           trimModel,
                           setTrimModel,
                           vehicleIndex,
                           setVehicleModel,
                           vehicleTypeName,
                           driveType,
                           setDriveType,
                           lockedVehicle,
                           onReload
                       }) => {
    const dispatch = useDispatch();
    const setPrimaryAndSecondaryVehicles = useSelector(
        getPrimaryandSecondaryVehicles
    );
    const getCompareImages = useSelector(setCompareImages)
    const {t} = useTranslation()
    const {pathname} = window.location;
    const colorCode = useSelector(exterirorColorCode);
    const compareGroup = useSelector(setCompareDataGroupInfo)
    const secondaryTrims = useSelector(getSortedCompareTrims);
    const secondariesVehicle = [];
    const filteredSecondaryVehicles = [];
    let changeSecondary = null;
    let trimCodes = useSelector(secondaryVehiclesTrims)
    const isLocked = useSelector(storeLockedCompetitors);
    const headerLoadType = useSelector(setHeaderLoadType);
    const selectedTrim = sessionStorage.getItem("selectedTrim")
    const handleConditionCheck = () => {
        onReload();
    };
    const showMakeSelector = headerLoadType != null || (vehicleIndex !== 0 && vehicleIndex !== "0");
    const isPrimaryChange = vehicleIndex === 0 && headerLoadType === null

    const handleCompareTrims = async () => {
        changeSecondary = vehiclesTrim
            .filter((trimCode) => trimCode.trim === selectedTrim)
            .map((vehicleCode) => vehicleCode.code)
        let seconds = [];
        let data = {}

        if (secondaryTrims.length) {
            let sortedTrims = [];
            if (changeSecondary.length > 0){
                sortedTrims = secondaryTrims.filter(item => item !== changeSecondary.toString()).slice(0, 3);
            } else {
                sortedTrims = secondaryTrims.filter(item => item !== changeSecondary.toString()).slice(0, 4);
            }

            if (sortedTrims.length) {
                changeSecondary.length > 0 && seconds.push({code: changeSecondary.toString()})
                sortedTrims.map((code) => {
                    if (code !== undefined) {
                        seconds.push({code: code})
                    }
                })
            }
            try {
                let postCompareFunction = pathname.includes("photos")
                    ? postCompareImages
                    : PostcompareData;
                data = {
                    code: seconds,
                    exterior: null
                }
                sessionStorage.removeItem("competitorsRemoved")
                const result = await dispatch(postCompareFunction(data));
                const error = result?.payload?.statusCode
                const isTrimSelected = JSON.parse(sessionStorage.getItem("isTrimSelected"));

                if (!result?.error && result?.payload?.vehicles) {
                    const newCompareGroup = getCompareGroupData(result.payload.vehicles, error, compareGroup);
                    dispatch(setCompareGroupData(newCompareGroup));
                    isTrimSelected ? trackCompareTrims(newCompareGroup) : trackCompareCompetitors(newCompareGroup);
                }

                if (result.payload.vehicles) {
                    let codes = result.payload.vehicles.map((vehicle) => ({ code: vehicle.code }));
                    checkLockedVehicle(lockedVehicle, codes);

                    const newData = {
                        code: codes,
                        exterior: null
                    };

                    await dispatch(setRemovedVehicle({remove: true, primaryChanged: true}))
                    if (Object.keys(lockedVehicle).length > 0) {
                        dispatch(pathname.includes("photos") ? postCompareImages(newData) : PostcompareData(newData));
                    }
                }
            } catch (error) {
                console.error("Error dispatching:", error);
            }
        }
        handleModalClose()
    }

    const handleUpdateClick = () => {
        if (vehicleIndex !== 0) {
            secondaries(vehicleData?.trim);
        } else {
            changeSecondary = vehiclesTrim
                .filter((trimCode) => trimCode.trim === selectedTrim)
                .map((vehicleCode) => vehicleCode.code)
            let seconds = [];
            let data = {}

            trimCodes.shift();
            seconds.push({code: changeSecondary.toString()})

            trimCodes.map((code) => {
                if (code !== undefined) {
                    seconds.push({code: code})
                }
            })

            data = {
                code: seconds,
                exterior: null
            }

            pathname.includes("photos")
                ? dispatch(postCompareImages(data))
                : dispatch(PostcompareData(data));

        }
        sessionStorage.removeItem("competitorsRemoved")
        handleModalClose()
        handleConditionCheck();
    };

    const handleCancelClick = () => {
        trackChangeVehicleCancel(compareGroup);
        handleModalClose();
    };

    const handleYearChange = (e) => {
        const selectedYear = e.target.value;
        setVehicleData({
            ...vehicleData,
            year: selectedYear,
            make: (vehicleIndex === 0 || vehicleIndex === "0") && headerLoadType === null ? vehicleData?.make : "",
            model: "",
            features: "",
            trim: '',
        });
        setVehicleModel(null);
        setTrimModel(null);
        setDriveType(null)
        if (selectedYear !== "") {
            isPrimaryChange ? dispatch(
                    searchMake([
                        selectedYear,
                        getKeyByValue(vehicleMake.vehicles, vehicleData?.make)
                    ])
                ) :
                dispatch(secondarySearch(selectedYear));
        } else {
            setVehicleMake(null);
        }
    };

    const handleMakeChange = (e) => {
        const selectedMake = e.target.value;
        setVehicleData({ ...vehicleData, make: selectedMake, model: '', trim: '', variation: '', selectedType: ''  });
        setVehicleModel(null);
        setTrimModel(null);
        setDriveType(null)
        if (selectedMake !== "") {
            dispatch(
                searchMake([
                    vehicleData?.year,
                    getKeyByValue(vehicleMake.vehicles, selectedMake)
                ])
            );
        }
    };

    const handleModelChange = (e) => {
        const selectedModel = getSelectedModel(vehicleModels, e.target.value)
        setTrimModel(null);
        setVehicleData({ ...vehicleData, model: e.target.value,  trim: '', variation: '', selectedType: '' });
        setDriveType(null);
        if (selectedModel !== "") {
            dispatch(fetchTrimData(selectedModel));
        }
    };

    const handleDriveTypes = (e) => {
        const selectedFeature = e.target.value;
        setVehicleData({ ...vehicleData, selectedType: selectedFeature, trim: '' });
        setTrimModel(trimModel)
    };

    const handleTrimChange = (e) => {
        const selectedTrim = e.target.value;
        sessionStorage.setItem("selectedTrim", selectedTrim);
        setVehicleData({ ...vehicleData, trim: selectedTrim });

    };

    const secondaries = async (selectedTrim) => {
        const storedValue = sessionStorage.getItem('featureSearch');
        await dispatch(isExpandedArr(true))
        await dispatch(setRemovedVehicle({remove: true}))
        sessionStorage.removeItem('expandedArr')
        let searchInput = document.querySelector('#feature-search-input');
        await dispatch(getExteriorColorCode(colorCode ? colorCode : null));
        const trimCode = [];
        handleModalClose();
        if (vehicleIndex === 0 || vehicleIndex === "0") {
            changeSecondary = vehiclesTrim
                .filter((trimCode) => trimCode.trim === selectedTrim)
                .map((vehicleCode) => vehicleCode.code);

            trimCode.push({ code: changeSecondary.length ? changeSecondary[0] : vehicleData?.code });
            const data = {
                code: trimCode,
                exterior: null
            };
            dispatch(setColorIcon(null));
            try {
                let postCompareFunction = pathname.includes("photos")
                    ? postCompareImages
                    : PostcompareData;
                sessionStorage.setItem('loadPrimaryOnReload', JSON.stringify(data));
                const result = await dispatch(postCompareFunction(data));
                const error = result?.payload?.statusCode

                if (!result.error && result.payload.vehicles) {
                    const newCompareGroup = getCompareGroupData(result.payload.vehicles, error, compareGroup);
                    dispatch(setCompareGroupData(newCompareGroup));
                    trackCompareCompetitors(newCompareGroup);
                }

                if (result.payload.vehicles) {
                    let codes = result.payload.vehicles.map((vehicle) => ({ code: vehicle.code }));
                    checkLockedVehicle(lockedVehicle, codes);

                    const newData = {
                        code: codes,
                        exterior: null
                    };

                    if (lockedVehicle) {
                        dispatch(pathname.includes("photos") ? postCompareImages(newData) : PostcompareData(newData));
                    }
                }
                sessionStorage.removeItem("competitorsRemoved")
            } catch (error) {

                console.error("Error dispatching:", error);
            }
        } else {
            dispatch(vehicleHasSwapped(true))
            changeSecondary = vehiclesTrim
                .filter((trimCode) => trimCode.trim === selectedTrim)
                .map((vehicleCode) => vehicleCode?.code);

            pathname.includes("photos")
                ? getCompareImages.map((vehicleCode) =>
                    secondariesVehicle.push(vehicleCode?.code)
                )
                : setPrimaryAndSecondaryVehicles.map((vehicleCode) =>
                    secondariesVehicle.push(vehicleCode?.code)
                );

            if (vehicleIndex >= 0 && vehicleIndex < secondariesVehicle.length) {
                secondariesVehicle[vehicleIndex] = changeSecondary[0];
            } else {
                // Push the new value into the array if the index is out of bounds
                secondariesVehicle.push(changeSecondary[0]);
            }
            secondariesVehicle.forEach((code) => {
                if (code !== undefined) {
                    filteredSecondaryVehicles.push({ code: code });
                }
            });


            const data = {
                code: filteredSecondaryVehicles,
                exterior: colorCode
            }
            pathname.includes("photos")
                ? dispatch(postCompareImages(data))
                : dispatch(PostcompareData(data));
        }
        dispatch(setCheckedFeature(false));
        dispatch(setAdvantagesCheck(true));
        dispatch(setCategories({ removeAll: true }))
        dispatch(getFeatuerSearch(""));
        sessionStorage.removeItem("isTrimSelected");

        if (
            !storedValue ||
            searchInput.toString() !== "" ||
            true ||
            undefined
        ) {
            sessionStorage.removeItem("featureSearch");
            const searchInput = document.querySelector("#feature-search-input");
            if (searchInput) searchInput.value = "";
        }
        trackChangeUpdateVehicle(compareGroup)
    };

    const checkLockedVehicle = (lockedVehicle, codes) => {
        for (const key in lockedVehicle) {
            if (Object.hasOwnProperty.call(lockedVehicle, key)) {
                const entries = lockedVehicle[key];

                entries.forEach(entry => {
                    const { vehicleIndex, lockStatus, vehicle } = entry;

                    if (lockStatus && vehicleIndex >= 0 && vehicleIndex < codes.length) {
                        codes[vehicleIndex] = { code: vehicle };
                    }
                });
            }
        }
    };

    const getDriveTypeValue = () => {
        if (vehicleData?.selectedType) {
            return vehicleData.selectedType;
        } else if (
            vehicleTypeName &&
            vehicleData?.features &&
            vehicleData?.features[vehicleTypeName]
        ) {
            return vehicleData.features[vehicleTypeName];
        } else {
            return "";
        }
    };

    const filterBySelectedType = (trim) => {
        if (vehicleData?.selectedType) {
            return trim.features[vehicleTypeName] === vehicleData?.selectedType;
        } else if (
            vehicleTypeName &&
            vehicleData?.features &&
            vehicleData?.features[vehicleTypeName]
        ) {
            return trim.features[vehicleTypeName] === vehicleData?.features[vehicleTypeName];
        }
    };

    function handleModalClose() {
        setOpenModal(false);
        sessionStorage.removeItem("selectedTrim")
        dispatch(setTrimVehiclesData([]));
    }

    return (
        <div className={"change-modal"} data-testid="change-modal">
            <ThemeProvider theme={modalTheme}>
                <Modal
                    open={openModal}
                    onClose={handleModalClose}
                    disableScrollLock={false}
                    hideBackdrop={false}
                >
                    <div className={"change-vehicle-modal"}>
                        <div className={"modal-container"}>
                            <div className={"modal-header"}>
                                <h4 className={"modal-title"}>
                                    { t("overview.changeSelectModal.changeVehicleTitle")}
                                </h4>
                                <button type="button"
                                        className={"close-compare"}>
                                    <CloseIcon fontSize={"small"}
                                               onClick={handleModalClose}
                                               data-testid="close-modal"/>
                                </button>
                            </div>

                        <div className={"change-modal-window"}>
                            <div className={"form-group"}>
                                <label className={"label-title"}>
                                    {t("overview.changeSelectModal.year")}:
                                </label>
                                <select
                                    id={"yearSelector"}
                                    className={"form-controls select-dropdown"}
                                    value={vehicleData?.year}
                                    onChange={handleYearChange}
                                >
                                    <option value="">{t("overview.changeSelectModal.select")}</option>
                                    {years &&
                                    years.map((vehicleYear) => (
                                        <option key={vehicleYear}>{vehicleYear}</option>
                                    ))}
                                </select>
                            </div>
                            { showMakeSelector && (
                                <div className={"form-group"}>
                                    <label className={"label-title"}>
                                        {t("overview.changeSelectModal.make")}:
                                    </label>
                                    <select
                                        className={"form-controls select-dropdown"}
                                        id={"makeSelector"}
                                        value={vehicleData?.make}
                                        onChange={handleMakeChange}
                                        data-testid="year-selector"
                                    >
                                        <option value="">{t("overview.changeSelectModal.select")}</option>
                                        {vehicleMake && (
                                            <React.Fragment>
                                                {vehicleMake && vehicleMake.vehicles && Object.values(vehicleMake.vehicles).map((make) => (
                                                    <option key={make} value={make}>
                                                        {make}
                                                    </option>
                                                ))}
                                            </React.Fragment>
                                        )}
                                    </select>
                                </div>
                            )}

                            {
                                <div className={"form-group"}>
                                        <label className={"label-title"}>
                                            {t('overview.changeSelectModal.model')}:
                                        </label>
                                        <select
                                            className={"form-controls select-dropdown"}
                                            id={"modelSelector"}
                                            value={vehicleData?.model}
                                            onChange={handleModelChange}
                                            data-testid="handleMakeChange"
                                        >
                                            <option value="">{t('overview.changeSelectModal.select')}</option>
                                            {vehicleModels && vehicleModels.vehicles &&
                                            Object.values(vehicleModels.vehicles).map(
                                                (model) => (
                                                    <option key={model} value={model}>
                                                        {model}
                                                    </option>
                                                )
                                            )}
                                        </select>
                                    </div>
                            }

                            {driveType && driveType.length > 1 ? (
                                <div className={"form-group"}>
                                    <label className={"label-title"}>
                                        {t(vehicleTypeName)}:
                                    </label>
                                    <select
                                        className={"form-controls"}
                                        id={"driveTypeSelector"}
                                        value={getDriveTypeValue()}
                                        onChange={handleDriveTypes}
                                    >
                                        <option value="">{t('overview.changeSelectModal.select')}</option>
                                        {driveType.map((type) => (
                                            <option key={type} value={type}>
                                                {type}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            ) : null}

                            <div className={"form-group"}>
                                <label className={"label-title"}>
                                    {t("overview.changeSelectModal.trim")}:
                                </label>
                                <select
                                    className={"form-controls"}
                                    id={"trimSelector"}
                                    value={vehicleData?.trim}
                                    onChange={handleTrimChange}
                                >
                                    <option value="">{t('overview.changeSelectModal.select')}</option>
                                    {trimModel &&
                                    (driveType && driveType.length > 1
                                        ? (trimModel &&
                                            trimModel
                                                .filter(filterBySelectedType)
                                                .map((trim) => (
                                                    <option key={trim.trim} value={trim.trim}>
                                                        {trim.trim}
                                                    </option>
                                                )))
                                        : trimModel &&
                                        trimModel.map((trim) => (
                                            <option key={trim.trim} value={trim.trim}>
                                                {trim.trim}
                                            </option>
                                        )))}
                                </select>
                            </div>
                        </div>

                            <div className="modal-footer-container">
                                <div className="change-modal-footer">
                                    <button
                                        className={vehicleData?.trim === selectedTrim ? 'primary-btn' : 'primary-btn-disabled'}
                                        onClick={handleUpdateClick}
                                        data-context="vehicle-change-modal-update"
                                        disabled={vehicleData?.trim !== selectedTrim && vehicleIndex === 0 || vehicleData === null}
                                    >
                                        {t('overview.changeSelectModal.update')}
                                    </button>
                                    <button
                                        type="submit"
                                        className="btn-default"
                                        onClick={handleCancelClick}
                                    >
                                        {t('overview.changeSelectModal.cancel')}
                                    </button>
                                </div>
                            </div>

                            {vehicleIndex === 0 && setPrimaryAndSecondaryVehicles[0] && (
                                <div className="compare-note">
                                    {t("overview.changeSelectModal.startNewCompare")}
                                </div>)
                            }

                            {vehicleIndex === 0 && setPrimaryAndSecondaryVehicles[0] && (
                                <CompareButton
                                    secondaryTrims={secondaryTrims}
                                    compareTrim={handleCompareTrims}
                                    secondaries={secondaries}
                                    isCompare={true}
                                    isLocked = {isLocked}
                                    vehiclesTrim={vehiclesTrim}
                                />
                            )}
                        </div>
                    </div>
                </Modal>
            </ThemeProvider>
        </div>
    );
};